import { PlusSVG } from 'src/components/Icons/Basic'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'
import { Dropdown } from 'react-bootstrap'

export const NewChatIcon = styled(PlusSVG)`
  font-weight: 900;
  width: 16px;
  height: 16px;
  fill: ${palette.neutral[600]};
`

export const ChatHistoryListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: auto;
  padding: 16px 0 100px;
  height: 100%;
`

export const ChatHistoryItemContainer = styled.a<{
  $isHighlighted?: boolean
}>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: left;
  justify-content: center;
  ${({ $isHighlighted }) =>
    $isHighlighted &&
    `
    border-radius: 6px;
    background-color: ${palette.neutral[50]};
  `}
  &:hover {
    border-radius: 6px;
    background-color: ${palette.neutral[50]};
  }
  text-decoration: none;
`

export const ChatHistoryItemTitle = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: ${palette.neutral[900]};
  white-space: nowrap;
  overflow: hidden;
  flex-grow: 1;
  padding: 8px;
`

export const ChatHistoryEmptyStateContainer = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${palette.neutral[900]};
  padding: 32px;
`

export const ChatHistoryGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ChatHistoryGroupDate = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${palette.neutral[900]};
`

export const ChatHistoryFilterToggle = styled(Dropdown.Toggle)`
  margin-left: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: none;
  outline: none;
  padding: 0;
  font-size: 12px;
  line-height: 18px;
  font-weight: 300;
  padding-left: 4px;
  padding-right: 4px;
  color: ${palette.neutral[900]};
  background-color: transparent;
  &:active,
  &:hover,
  &:focus {
    background-color: ${palette.neutral[50]};
    color: ${palette.neutral[900]};
    box-shadow: none;
    border: none;
  }
  &:focus {
    background-color: transparent;
  }
  &.btn-primary:active:focus {
    box-shadow: none;
  }
`

export const ChatHistoryFilterItem = styled(Dropdown.Item)`
  font-size: 12px;
  line-height: 18px;
  color: ${palette.neutral[900]};
`

export const ChatHistoryFilterDropdown = styled(Dropdown)`
  &.show > .btn-primary.dropdown-toggle {
    background-color: ${palette.neutral[50]};
    border-color: ${palette.neutral[50]};
    color: ${palette.neutral[900]};
    box-shadow: none;
  }
`
